
import {  SlotGameType1_3 } from "../SlotGameType1_3";
// namespace SlotGames3
// {
	export class LavaLand20233 extends SlotGameType1_3
	{
	}
// }